import { isBrowser } from '../../../play-core/utils/ssr-helper';
export const isAndroid = isBrowser && /Android/i.test(window.navigator.userAgent);